export enum CalculatorScopes {
  CAN_MARK_CALCULATOR_FOR_REVIEW = 'can_mark_calculator_for_review',
}
